import i18n from "@/config/i18n.config";

type GraphqlBackendError = {
  code: string;
  message: string;
};

export function getErrorMessageFromCode(code: string) {
  return i18n.t(`backend_errors.${code}`);
}

export function getErrorMessageFromBackendError(error: GraphqlBackendError) {
  return getErrorMessageFromCode(error.code) ?? error.message;
}
